import { jsxs, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import ndsTokens from 'nicollet-tokens';
import { ndsFontReset } from '@nicollet/common';
import { LogoSection } from './components/LogoSection.js';
import { LinksSection } from './components/LinksSection.js';
import { MenusSection } from './components/MenusSection.js';

const Wrapper = styled.div.attrs({
  id: 'footer',
  'data-test': 'footer'
})`
  ${ndsFontReset({
  color: ndsTokens.colors.text.onLight.primary
})};
  text-align: center;
  padding-top: ${ndsTokens.space.generic.x3};
  padding-bottom: ${ndsTokens.space.generic.x6};
  background-color: ${ndsTokens.colors.palette.gray.lightest};
`;

const Footer = ({
  children,
  menusSection,
  linksSection,
  logoSection,
  ...restProps
}) => jsxs(Wrapper, Object.assign({}, restProps, {
  children: [children, jsx(MenusSection, Object.assign({}, menusSection), void 0), jsx(LinksSection, Object.assign({}, linksSection), void 0), jsx(LogoSection, Object.assign({}, logoSection), void 0)]
}), void 0);

Footer.displayName = 'Footer';

export { Footer };
